// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2r8xA","inner":"Footer_inner__1laZG"};